import { Info } from 'lucide-react';

interface AssignmentInfoBannerProps {
  variant: 'assigned-to-other' | 'unassigned';
  assigneeName?: string;
}

export const AssignmentInfoBanner = ({ variant, assigneeName }: AssignmentInfoBannerProps) => {
  const message =
    variant === 'assigned-to-other'
      ? `Assigned to ${assigneeName ?? 'another rep'}.`
      : 'No assigned rep.';

  return (
    <div className="mb-3 flex items-start gap-2 rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-xs text-gray-700 dark:border-gray-700 dark:bg-gray-800/40 dark:text-gray-300">
      <Info className="mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-gray-400 dark:text-gray-500" />
      <span>{message}</span>
    </div>
  );
};
